/* eslint-disable */
(function() {
  var $ = require('jquery');

  var $footerlinks = $('.footer-links');

  function footerLinks() {
    if ($(window).innerWidth() < 551) {
      //slide toggle footer links on click add/remove class
      $footerlinks.find('h3').click(function() {
        if (
          !$(this)
            .parent($footerlinks)
            .hasClass('footer-open')
        ) {
          $(this)
            .parent($footerlinks)
            .addClass('footer-open');
          $(this)
            .siblings('ul')
            .stop()
            .slideDown();
        } else {
          $(this)
            .parent($footerlinks)
            .removeClass('footer-open');
          $(this)
            .siblings('ul')
            .stop()
            .slideUp();
        }
      });
    }
  }

  if ($(window).innerWidth() < 551) {
    footerLinks();
  }

  $(window).resize(function() {
    $footerlinks.find('h3').unbind();

    if ($(window).innerWidth() < 551) {
      footerLinks();
    }
  });
})();
